/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiTemplate.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-template";

export class AutogenModelEdiTemplate<RowType extends ModelRow> extends Endpoint<RowType, RowEdiTemplateFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiTemplate extends ModelRow<RowEdiTemplateFields> {
	constructor(values?: Partial<RowEdiTemplateFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiTemplateFields {
	ack_required: string;
	app_receiver_code: string;
	app_receiver_id: string;
	app_sender_code: string;
	app_sender_id: string;
	authen_info: string;
	authen_info_qual: string;
	company_id: string;
	ctl_version: string;
	ctl_version_qual: string;
	descr: string;
	direction: string;
	ele_separator: number;
	end_of_line_1: number;
	end_of_line_2: number;
	filepath: string;
	format_type: string;
	functional_id: string;
	id: number;
	industry: string;
	is_multi_partner: string;
	name: string;
	parse_batch_number: string;
	parse_create_date: string;
	parse_create_datef: string;
	parse_fg_segment: string;
	parse_tran_ctrl_no: string;
	parse_tran_segment: string;
	receiver_id: string;
	receiver_qual: string;
	secur_info: string;
	secur_info_qual: string;
	sender_id: string;
	sender_qual: string;
	spec_footer_text: string;
	spec_header_text: string;
	spec_title: string;
	standard: string;
	subele_separator: number;
	tag_format_text: string;
	test_indicator: string;
	transaction_set: string;
	transaction_type: string;
	translation_method: string;
	update_date: Date;
	version: string;
}

